import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { Link as RouterLink } from "react-router-dom";

export function BlogBreadcrumbs({ items = [] }) {
  return (
    <Breadcrumbs sx={{ mb: 2, fontFamily: "Heebo" }}>
      {items.map((item, idx) =>
        item.href && idx < items.length - 1 ? (
          <Link
            key={idx}
            component={RouterLink}
            to={item.href}
            underline="hover"
            sx={{ color: "#065F46", fontFamily: "Heebo", fontSize: 14 }}
          >
            {item.label}
          </Link>
        ) : (
          <Typography key={idx} sx={{ color: "#362B24", fontFamily: "Heebo", fontSize: 14 }}>
            {item.label}
          </Typography>
        )
      )}
    </Breadcrumbs>
  );
}
